import { TYPE_HEADER, TYPE_PARAGRAPH } from '~pricing/lib/packageFeatures/tooltipCopy';

const { defineMessages } = require('@sm/intl');

export default defineMessages({
  analyze_export_enabled_tooltip: undefined,
  analyze_export_spss_enabled_tooltip: undefined,
  phone_support_tooltip: undefined,
  email_support_tooltip: undefined,
  priority_email_support_tooltip: undefined,
  analyze_combine_filters_tooltip_heading: {
    id: 'PricingDetails.Feature.CombineFiltersTooltipHeading',
    defaultMessage: 'Filter and compare results',
    desc: TYPE_HEADER,
  },
  analyze_combine_filters_tooltip: {
    id: 'PricingDetails.Feature.CombineFiltersTooltip',
    defaultMessage:
      'Filter your results and compare how different groups answered the questions in your survey. Segment your data to uncover trends and correlations in your data.',
    desc: TYPE_PARAGRAPH,
  },
  create_logo_enabled_tooltip_heading: {
    id: 'PricingDetails.Feature.CreateLogoEnabledTooltipHeading',
    defaultMessage: 'Add your logo',
    desc: TYPE_HEADER,
  },
  create_logo_enabled_tooltip: {
    id: 'PricingDetails.Feature.CreateLogoEnabledTooltip',
    defaultMessage: `Make your survey stand out. Add a custom image or logo, and personalize the work you send.`,
    desc: TYPE_PARAGRAPH,
  },
  create_piping_enabled_tooltip_heading: {
    id: 'PricingDetails.Feature.CreatePipingEnabledTooltipHeading',
    defaultMessage: 'Question & answer piping',
    desc: TYPE_HEADER,
  },
  create_piping_enabled_tooltip: {
    id: 'PricingDetails.Feature.CreatePipingEnabledTooltip',
    defaultMessage: `Take respondents' answers from a previous question to personalize questions on a later page in the survey.`,
    desc: TYPE_PARAGRAPH,
  },
  quizzes_pro_tooltip_heading: {
    id: 'PricingDetails.Feature.QuizzesProTooltipHeading',
    defaultMessage: 'Quizzes pro',
    desc: TYPE_HEADER,
  },
  quizzes_pro_tooltip: {
    id: 'PricingDetails.Feature.QuizzesProTooltip',
    defaultMessage:
      'Show custom feedback for correct, partially correct, and incorrect responses as people take your quiz. At the end, show people custom feedback based on their overall score. Quizzes Pro also lets you email people their quiz results automatically, or export your quiz statistics in PDF, XLS, and CSV format.',
    desc: TYPE_PARAGRAPH,
  },
});
